module.exports = __webpack_public_path__ + "img/logo_tron_ungu.38f604dd.png";